// Wallet Ops — section layout for the crypto wallet rail (SM-211).
//
// One page per job, mirroring the Treasury › Fees split:
//
//   /wallet-ops/config     networks / assets / rates / flags / policies
//   /wallet-ops/orders     deposits / withdrawals / gas / collections
//   /wallet-ops/custody    custody wallet directory
//   /wallet-ops/blacklist  address blacklist
//   /wallet-ops/health     chain-scan pipeline health
//
// This file only mounts the children; /wallet-ops itself redirects to
// the Config page (see wallet-ops.index.tsx).
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/wallet-ops")({
  component: Outlet,
});
